/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */

import PaletteIconCaretDown from '@telus-uds/palette-allium/build/rn/icons/CaretDown'
import PaletteIconStatusSuccess from '@telus-uds/palette-allium/build/rn/icons/StatusSuccess'
import PaletteIconStatusError from '@telus-uds/palette-allium/build/rn/icons/StatusError'
import PaletteIconCaretUp from '@telus-uds/palette-allium/build/rn/icons/CaretUp'
const theme = {
  appearances: {
    active: { type: 'state', values: [ true ] },
    focus: {
      description: 'Focus states for some input elements are well supported across web, RN, ios and android',
      type: 'state',
      values: [ true ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    },
    validation: {
      description: 'Validation states for form inputs',
      type: 'state',
      values: [ 'error', 'success', 'warning', 'feature' ]
    }
  },
  rules: [
    { if: { hover: true }, tokens: { outerBorderColor: '#e3e6e8' } },
    {
      if: { focus: true },
      tokens: { borderColor: '#7c53a5', borderWidth: 3 }
    },
    {
      if: { validation: 'success' },
      tokens: {
        borderColor: '#2b8000',
        feedbackBackgroundColor: '#f4f9f2',
        validationIcon: PaletteIconStatusSuccess,
        validationIconColor: '#2b8000'
      }
    },
    {
      if: { validation: 'error' },
      tokens: {
        borderColor: '#e12339',
        feedbackBackgroundColor: '#fff6f8',
        validationIcon: PaletteIconStatusError,
        validationIconColor: '#e12339'
      }
    },
    {
      if: { inactive: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#f4f4f7',
        color: '#676e73',
        icon: null
      }
    },
    { if: { active: true }, tokens: { icon: PaletteIconCaretUp } }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#676e73',
    borderRadius: 4,
    borderWidth: 1,
    color: '#414547',
    feedbackBackgroundColor: '#f4f4f7',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '400',
    height: 48,
    icon: PaletteIconCaretDown,
    iconColor: '#414547',
    iconSize: 20,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderWidth: 2,
    paddingBottom: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    validationIcon: null,
    validationIconColor: 'rgba(0, 0, 0, 0)',
    validationIconSize: 20
  }
}
export default theme
